export const KB: number = 1024;
export const MB: number = KB * KB;
export const GB: number = MB * KB;
